<template>
  <div id="header-container">
    <!-- <h1>{{this.router_view_name.toUpperCase()}}</h1> -->
    <div class="items-container" v-if="loggedIn">
      <h1 class="user-item">{{user}}</h1>
      <button class="items" @click="assignments">Assignments</button>
      <button class="items" @click="schedule">Schedule</button>
      <button class="items" @click="signOut">Sign out</button>
    </div>
    <div class="items-container" v-else>
      <button class="items" @click="home" v-if="!(this.router_view_name.includes('home'))">Home</button>
      <button class="items" @click="login">Login</button>
      <button class="items" @click="register">Register</button>
    </div>
    <hr />
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "top-header",
  data() {
    return {
      loggedIn: false,
      user: ""
    };
  },
  mounted() {
    this.setupFirebase();
  },
  computed: {
    router_view_name() {
      return this.$route.name || "";
    }
  },
  methods: {
    setupFirebase() {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          this.user = user.email.split("@")[0];
          this.user = this.user.charAt(0).toUpperCase() + this.user.slice(1);
          // User is signed in.
          // console.log("signed in");
          this.loggedIn = true;
        } else {
          this.user = "";
          // No user is signed in.
          this.loggedIn = false;
          // console.log("signed out", this.loggedIn);
        }
      });
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({ name: "home" });
        });
    },
    login() {
      if (!this.router_view_name.includes("login"))
        this.$router.push({ name: "login" });
    },
    register() {
      if (!this.router_view_name.includes("register"))
        this.$router.push({ name: "register" });
    },
    home() {
      if (!this.router_view_name.includes("home"))
        this.$router.push({ name: "home" });
    },
    assignments() {
      if (!this.router_view_name.includes("assignments"))
        this.$router.replace({ name: "assignments" });
    },
    schedule() {
      if (!this.router_view_name.includes("schedule"))
        this.$router.replace({ name: "schedule" });
    }
  }
};
</script>

<style scoped>
#header-container {
  display: flex;
  flex-flow: column-reverse;
}

.items-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border: 1px solid lightgray;
}

.user-item {
  padding: 0 10px;
}

.items {
  border: 1px solid lightgray;
  padding: 0px 7px;
  height: 50px;
  width: 90px;
  justify-self: end;
}

.items:hover {
  background-color: darkgrey;
  color: white;
}
</style>